import { lazy } from "react";
import { authRoles } from "app/auth/authRoles";
import Loadable from "app/components/Loadable";

const Analytics2 = Loadable(lazy(() => import("./analytics-2")));


const dashboardRoutes = [
  { path: "/dashboard/default", element: <Analytics2 />, auth: authRoles.admin },
];

export default dashboardRoutes;
